/**
 * Makes the input safe to use as a field name
 * @param input the string to sanitize
 * @returns a sanitized version of the input string (lowercase, underscores instead of spaces, no special characters)
 */
export function sanitizeName(input: string): string {
  if (!input) return input;

  return input
      .toLowerCase()
      .replace(/\s+/g, "_")
      .replace(/[^\w]/g, "");
}